import { render, staticRenderFns } from "./DialoError.vue?vue&type=template&id=d7817ce2"
import script from "./DialoError.vue?vue&type=script&lang=ts"
export * from "./DialoError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports